import { ContentHeader, Text } from '@croquiscom-pvt/zds';

interface Props {
  main_title?: string;
  sub_title?: string;
  is_ad?: boolean;
}

export const Title = ({ main_title, sub_title, is_ad = false }: Props) => {
  return (
    <ContentHeader
      title={
        <>
          {main_title}
          <br />
          <Text variant='Body_13_Regular' v3Color='gray600' style={{ marginTop: 4 }}>
            {sub_title}
          </Text>
        </>
      }
      right={is_ad ? [{ type: 'ad' }] : []}
    ></ContentHeader>
  );
};
